

import MILAAP1 from "./Assets/Projects/milaap1.png";
import MILAAP2 from "./Assets/Projects/milaap2.png";
import MILAAP3 from "./Assets/Projects/milaap3.png";










export const PROJECTS = [
  {
    image1: "https://user-images.githubusercontent.com/103960628/193427517-21406fb5-b47e-430e-a1c9-000ff89e303e.png",
    image2: "https://user-images.githubusercontent.com/103960628/193427595-627574e6-bb92-4a24-8306-3b32abc1c90d.png",
    image3: "https://user-images.githubusercontent.com/103960628/193427648-eb41159d-3a11-4398-8387-260e5f68f499.png",
    name: "Toggl Track Website Clone",
    technologyUsed: "React | Firebase | Chakra ui | Json-server | HTML | CSS | Mongo-db",
    description: "Toggl Track is a time tracking and project management website. We have cloned this website within 5 days where we used ReactJS, Css, ExpressJS, NodeJS and MongoDB to create the whole Frontend and the Backend",
    url: "https://toggll-track-clone.netlify.app/",
    git:"https://github.com/altaf100001/Toggl-Track-Clone",
  },
  {
    image1: MILAAP1,
    image2: MILAAP2,
    image3: MILAAP3,
    name: "Milaap website clone",
    technologyUsed: "React | Redux | Firebase | Chakra ui | Json-server | HTML",
    description: "Milaap is an online crowdfunding platform that enables anyone across India to raise funds for healthcare, education, sports, disaster relief and other personal causes, with great ease. ",
    url: "https://milaap-peach.vercel.app/",
    git:"https://github.com/anowar265/sordid-authority-4005",
  },
  // {
  //   image1: YOOX1,
  //   image2: YOOX2,
  //   image3: YOOX3,
  //   name: "Yoox website clone",
  //   technologyUsed: "HTML | CSS | JavaScript",
  //   description: "Yoox.com is a Global e-commerce brand of Italian Origin. Yoox was originally founded by Federico Marchetti in Milan in 2000. YOOX is the world's leading online store for fashion, design and art that lasts a lifetime and beyond. This is a team project, built by us in the Construct Week - Unit 3 at Masai School.",
  //   url: "https://yooox.netlify.app",
  //   git:"https://github.com/aadarsh11433/PROJECTYOOX",
  // },
  
];

export const SKILLS = [
  { name: "FrontEnd Development", initialRating: 4 },
  { name: "Data Structures and Algorithm", initialRating: 3 },
  { name: "Communication Skills", initialRating: 3 },
  { name: "Backend Development", initialRating: 3 },
 
];

export const TOOLS = ["Visual Studio Code", "Git", "Chrome DevTools", "Npm (Node Package Manager)",    "Heroku", "Postman"]

// export const SKILLSIMG = [
  
//   "https://i.imgur.com/lQAuvKs.png",
//   "https://i.imgur.com/twIIEdi.png",
//   "https://i.imgur.com/ecasivn.png",
//   "https://i.imgur.com/h1RrQ2Q.png",
//   "https://i.imgur.com/H5H3UjC.png",
//   "https://i.imgur.com/DXg6u5g.png",
//   "https://i.imgur.com/r4zozSY.png",
//   "https://i.imgur.com/mejWGfl.png"

// ]

// export const SKILLSNAME = [
//   "HTML","JavaScript","CSS","React","Redux","Express","MongoDB","Material-UI"
// ]

export const SKILL =[

  {img:"https://i.imgur.com/lQAuvKs.png",name:"HTML"},
  {img:"https://i.imgur.com/twIIEdi.png",name:"JavaScript"},
  {img:"https://i.imgur.com/ecasivn.png",name:"CSS"},
  {img:"https://i.imgur.com/h1RrQ2Q.png",name:"React"},
  {img:"https://i.imgur.com/H5H3UjC.png",name:"Redux"},
  {img:"https://i.imgur.com/DXg6u5g.png",name:"Express"},
  {img:"https://i.imgur.com/r4zozSY.png",name:"MongoDB"},
  {img:"https://i.imgur.com/mejWGfl.png",name:"Material-UI"},

]

// data edited
